import React, { useState, useEffect } from "react";
import "./App.css";
// import { ReactSVG } from "react-svg";
// import SvgComp from "./SvgComp";
import bgImg from "./assets/newwebbg.jpg";
import mobilebg from "./assets/mobile.jpg"

const country = [
  {
    areaName: "North America",
    countryInfo: [
      {
        name: "United States",
        link: "https://www.amazon.com/stores/page/9623E9E3-AB88-470E-8FFD-F5B6DBB7A75C",
        svgLink: require("./assets/USA.svg"),
        iconName: 'icon-USA',
      },
      {
        name: "Canada",
        link: "https://www.amazon.ca/stores/page/5D149D02-7042-448D-B479-EA75C2F29695",
        svgLink: require("./assets/Canada.svg"),
        iconName: 'icon-Canada'
      },
      {
        name: "Mexico",
        link: "https://www.amazon.com.mx/dp/B07S2RKNHJ?ref=myi_title_dp",
        svgLink: require("./assets/Mexico.svg"),
        iconName: 'icon-Mexico'
      }
    ],
  },
  {
    areaName: "Europe",
    countryInfo: [
      {
        name: "United Kingdom",
        link: "https://www.amazon.co.uk/stores/page/DA02B9C0-096B-4882-8591-0B321BB51869",
        svgLink: require("./assets/UK.svg"),
        iconName: 'icon-UK'
      },
      {
        name: "Deutschland",
        link: "https://www.amazon.de/lava",
        svgLink: require("./assets/Deutschland.svg"),
        iconName: 'icon-Deutschland'
      },
      {
        name: "France",
        link: "http://www.amazon.fr/dp/B09DX58FCS?ref=myi_title_dp",
        svgLink: require("./assets/France.svg"),
        iconName: 'icon-France'
      },
      {
        name: "Italia",
        link: "https://www.amazon.it/lava",
        svgLink: require("./assets/Italia.svg"),
        iconName: 'icon-Italia'
      },
      {
        name: "España",
        link: "http://www.amazon.es/dp/B09DX58FCS?ref=myi_title_dp",
        svgLink: require("./assets/Espana.svg"),
        iconName: 'icon-Espana'
      },
      {
        name: "Nederland",
        link: "https://www.amazon.de/lava",
        svgLink: require("./assets/Nederland.svg"),
        iconName: 'icon-Nederland'
      },
      {
        name: "Sverige",
        link: "https://www.amazon.de/stores/page/4CC965C8-3B78-41CB-A612-3495A140CC95?ingress=3",
        svgLink: require("./assets/Sverige.svg"),
        iconName: 'icon-Sverige'
      }
    ],
  },
  {
    areaName: "Asia / Oceania",
    countryInfo: [
      {
        name: "日本",
        link: "http://www.amazon.co.jp/dp/B09C1J62LD?ref=myi_title_dp",
        svgLink: require("./assets/Janpa.svg"),
        iconName: 'icon-Janpa'
      },
      {
        name: "Singapore",
        link: "https://www.amazon.sg/dp/B07THL682P?ref=myi_title_dp",
        svgLink: require("./assets/Singapore.svg"),
        iconName: 'icon-Singapore'
      },
      {
        name: "Australia",
        link: "http://www.amazon.com.au/dp/B09BZT2RTQ?ref=myi_title_dp",
        svgLink: require("./assets/Australia.svg"),
        iconName: 'icon-Australia'
      },
      {
        name: "امارات عربية متحد",
        link: "https://www.amazon.ae/dp/B08J6B69G6?ref=myi_title_dp",
        svgLink: require("./assets/Alianqiu.svg"),
        iconName: 'icon-Alianqiu'
      },
    ],
  },
];
function RenderCountry() {
  return country.map((area, areaIndex) => (
    <div className="area-wrapper" key={"area" + areaIndex}>
      <p className="area-name">{area.areaName}</p>
      <p>
        {area.countryInfo.map((country) => (
          <a className="country-wrapper" key={country.name} href={country.link} target="blank">
            <img className="svg-wrapper" src={country.svgLink} />
            {/* <SvgComp svgName={`#${country.iconName}`}></SvgComp> */}
            <span className="country-name">{country.name}</span>
          </a>
        ))}
      </p>
    </div>
  ));
}
function App() {
  const [bgUrl, setBg] = useState(`url(${bgImg})`)
  useEffect(() => {
    const clientWidth = document.documentElement.clientWidth
    setBg(clientWidth >= 450 ? `url(${bgImg})` : `url(${mobilebg})`)
  }, [])
  return (
    <div className="container">
      <header className="header-wrapper">
        <img src={require('./assets/logo.svg')} />
        {/* <SvgComp forName="logo" svgName="#icon-logo"></SvgComp> */}
      </header>
      <div
        className="main-wrapper"
        style={{ backgroundImage: bgUrl }}
      >
        {/* <ReactSVG className="amazonlogo" src={require('./assets/amazonlogo.svg')} /> */}
        {/* <img className="amazonlogo" src={require('./assets/amazon.png')} /> */}
        {/* <div className="amazonlogo">
        <SvgComp forName="amazonlogo" svgName="#icon-amazonlogo"></SvgComp>
        </div> */}
        <div className="center-wrapper">
          <div className="inner-container">
            {/* <h1 className="title">20% Off on Amazon PrimeDay!</h1> */}
            <h1 className="title">
              Select your region to view products
            </h1>
            {/* <h2 className="date">Oct. 13-14th</h2> */}
            <p className="tip">
                Click the region you will be redirected to new page for amazon
                store.
            </p>
            {RenderCountry()}
            <p className="maile">
              Amazon store customer service:
              <a href="mailto:service@lavamusic.com">amazon.service@lavaguitar.com</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
